import React from 'react';
import {styled} from '@mui/material/styles';
import {SxProps, Typography} from '@mui/material';

interface UITitleMenuProps {
  children: React.ReactNode;
  sx?: SxProps;
}

const StyledTypography = styled(Typography, {})<UITitleMenuProps>(({theme}) => ({
  textTransform: 'uppercase',
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: '1.2px',
  lineHeight: '120%',
  color: theme.palette.grey[200],
  fontFamily: "Pragmatica Extended, arial, sans-serif"
}));

const TitleMenu: React.FC<UITitleMenuProps> = ({
                                                 children,
                                                 sx
                                               }) => {
  return (
    <StyledTypography sx={sx}>
      {children}
    </StyledTypography>
  );
};


export default TitleMenu;
